import React from 'react';
import useContentReactions from '@/hooks/content/useContentReactions';
import FocusedLoopItem from '@/modules/content/loop/FocusedLoopItem';
import FocusedLoopRail from '@/modules/content/loop/FocusedLoopRail';
import { TContent } from '@/types/Content.types';

type Props = {
  content: TContent;
  isActive: boolean;
  nav: React.ReactNode;
  onPlayStateChange: (isPlaying: boolean) => void;
  onProgress: (currentTimeSeconds: number, durationSeconds: number) => void;
};

// Binds the per-item reactions hook once and hands the results to the variant.
//
// The rail and navigation are passed down rather than positioned by the shell: only the
// variant knows where its media edge is, and the media has to stay the centre of the row
// for it to land on the true centre of the screen.
const LoopItemWithActions = ({ content, isActive, nav, onPlayStateChange, onProgress }: Props) => {
  const { markNotInterested, report } = useContentReactions(content);

  return (
    <FocusedLoopItem
      content={content}
      isActive={isActive}
      onNotInterested={markNotInterested}
      onReport={(reason) => report({ reason })}
      onPlayStateChange={onPlayStateChange}
      onProgress={onProgress}
      rail={<FocusedLoopRail content={content} />}
      nav={nav}
    />
  );
};

export default LoopItemWithActions;
